import { render, staticRenderFns } from "./Rascunhos.vue?vue&type=template&id=4fb5f3ae&"
import script from "./Rascunhos.vue?vue&type=script&lang=js&"
export * from "./Rascunhos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports